import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { recoverSession } from '../actions'
import { isAuthenticated, canRecover } from '../services/sessionService'
import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import { Layout, Form, Input, Button, Spin, message } from 'antd';
const FormItem = Form.Item;
const { Content, Footer } = Layout;



/**
 * Login view
 */

class PasswordRecovery extends Component {

	static propTypes = {
        session: PropTypes.object,
        recoverSession: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        loading: false,
        code: null
    }

    confirmDirty = false

    componentWillMount() {
        const { session, location, history } = this.props

        const code = new URLSearchParams(location.search).get("code")
        if (code) {
            this.setState({ code: code })
        } else {
            history.push('/login')
        }

        if (!isAuthenticated(session)) {
            if (canRecover(session)) {
                if (!session.isRecovering) {
                    this.props.recoverSession()
                    return;
                }
            }
        }
    }

    handleConfirmBlur = (e) => {
        this.confirmDirty = this.confirmDirty || !!e.target.value
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form
        if (value && this.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true })
        }
        callback()
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback(this.props.intl.formatMessage({id: 'profile.passwordDoNotMatch'}))
        } else {
            callback()
        }
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true })
                const { intl, history } = this.props
                callApi({
                    endpoint: 'recovery/' + this.state.code,
                    method: 'POST',
                    body: { newPassword: values.newPassword }
                }).then((data) => {
                    history.push({ pathname: '/message', state: { name: 'passwordChanged' }})
                    return
                }).catch((err) => {
                    if (err.status === 429) {
                        message.warn(intl.formatMessage({id: 'misc.tooManyRequests'}))
                    } else if (err.code === 10) {
                        message.warning(intl.formatMessage({id: 'passwordChange.passwordRecoveryCodeExpired'}))
                    } else {
                        message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    }
                    this.setState({ loading: false })
                })
            }
        })
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { session, location, intl } = this.props;
        const { loading } = this.state;

        if (session.isRecovering && !loading) {
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }
        if (session.user) {
            if (location.state && location.state.from) {
                return (<Redirect to={location.state.from} />)
            }
            return (<Redirect to={{ pathname: "/" }} />)
        }

        return (
            <Layout style={{ minHeight: '100vh', background: '#fff' }}>
                <Content style={{ margin: '16px' }}>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <h1><FormattedMessage id="passwordChange.changePassword" /></h1>
                        <p>Choisissez un nouveau mot de passe</p>
                        <FormItem>
                            {getFieldDecorator('newPassword', {
                                rules: [
                                    {required: true, message: intl.formatMessage({id: 'passwordChange.newPasswordRequired'})},
                                    {validator: this.checkConfirm}
                                ]
                            })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" placeholder={intl.formatMessage({id: 'passwordChange.newPassword'})} />)}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('confirmPassword', {
                                rules: [
                                    {required: true, message: intl.formatMessage({id: 'passwordChange.confirmPasswordRequired'})},
                                    {validator: this.checkPassword}
                                ]
                            })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} onBlur={this.handleConfirmBlur} type="password" placeholder={intl.formatMessage({id: 'passwordChange.confirmPassword'})} />)}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}><FormattedMessage id="passwordChange.changePassword" /></Button>
                            <div style={{ marginTop: '30px' }}><Link to="/login"><FaIcon fixedWidth icon="arrow-left" /> <FormattedMessage id="message.backToLogin" /></Link></div>
                        </FormItem>
                    </Form>
                </Content>
                <Footer style={{ textAlign: 'center', background: '#f8f8f8' }}>
                    &copy; 2020 - <FormattedMessage id="footer.createdBy" /> <a href="https://www.neoxis.be"><FaIcon icon="code" /> Neoxis</a>
                </Footer>
            </Layout>
        )
    }
    
}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    recoverSession
})(Form.create()(PasswordRecovery))))


// WEBPACK FOOTER //
// ./src/containers/PasswordChange.js